import { DataGrid } from "@mui/x-data-grid";
import { subHistoryColumns } from "../../datatablesource";
import { useEffect, useState } from "react";

import fetchURLForm from "../../../../functions/fetchURLForm";
import { fetchUrl } from "../../../../functions/fetchUrl";


import TextField from "@mui/material/TextField";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

const SubDayPercent = ({ table }) => {
  // console.log("Table: " + table)
  useState("Loading...");
  const today = new Date();

  const [dataPercent, setDataPercent] = useState([]);
  console.log("State", dataPercent)


  const [valueDateFrom, setValueDateFrom] = useState(today);

  const columns = [
    {
      field: "unsub_today",
      headerName: "Unsub Day",
      width: 100,
    },
    {
      field: "revenue_today",
      headerName: "Unsub Revenue",
      width: 150,
    },
    {
      field: "pct_today",
      headerName: "% of Revenue",
      width: 180,
    },
    {
      field: "total_revenue_today",
      headerName: "Total of Day",
      width: 150,
    },


    {
      field: "revenue_yesterday",
      headerName: "Unsub Day Before",
      width: 100,
    },
    {
      field: "pct_yesterday",
      headerName: "% of Day Before",
      width: 150,
    },
    {
      field: "total_revenue_yesterday",
      headerName: "% from Total",
      width: 150,
    },
  ];

  // console.log(dataOoredoo);

  useEffect(() => {
    setDataPercent([])

    const monthFromNumber = (valueDateFrom.getMonth() + 1).toString().padStart(2, "0");
    const dayFromNumber = valueDateFrom.getDate().toString().padStart(2, "0");
    const yearFromNumber = valueDateFrom.getFullYear();


    const dateFrom = monthFromNumber + "-" + dayFromNumber + "-" + yearFromNumber;

    const bodySend = {
      valueDate: dateFrom,
    };

    const fetchData = async () => {
      const response = await fetchUrl({
        apiName: table,
        method: "POST",
        reqBody: bodySend
      });
      if (response.success) {
        console.log("Result", response.result[0]);
        // setDataPercent(response.result[0])
        setDataPercent([{
          ...response.result[0],
          id: 1, // Or any unique identifier
        }]);
      }
    };
    fetchData();




  }, [table, valueDateFrom]);

  return (
    <>
      <div style={{ display: 'flex', flexDirection: 'row' }}>
        <div style={{ display: "inline-block", margin: "10px 10px" }}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="From:"
              value={valueDateFrom}
              onChange={(newValue) => {
                setValueDateFrom(new Date(newValue));
              }}
              renderInput={(params) => <TextField {...params} />}
            />
          </LocalizationProvider>
        </div>

      </div>

      <>
        <div style={{ display: 'flex' }}>
          <div style={{ width: '100%', margin: '5px' }}>
            <DataGrid
              className="ml-1"
              rows={dataPercent}
              columns={columns}
              pageSize={8}
              rowsPerPageOptions={[5]}
              getRowId={(data) => data.id}
              style={{ height: "40vh" }}
            />
          </div>
        </div>
      </>

    </>

  );
};

export default SubDayPercent;
